import { Emoji, Message, Wrapper } from './MobileSupport.style';

export type MobileSupportProps = {};

export function MobileSupport(_props: MobileSupportProps) {
  return (
    <Wrapper className='MobileSupport-wrapper' data-testid='MobileSupport-wrapper'>
      <Emoji>📱</Emoji>
      <Message>
        We currently do not support mobile devices. Please use a desktop or laptop to access the
        full functionality of our webapp.
      </Message>
    </Wrapper>
  );
}

export default MobileSupport;
